import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/(site)/fasilitas/page.tsx");
